// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Styling */
.sidebarContainer {
  background-color: #f9f9f9;
  width: 240px;
  height: 100vh;
  padding: 20px;
  border-right: 1px solid #ddd;
}

.submenuClient p {
  font-weight: bold;
  margin: 10px 0;
}

.submenuClient li {
  list-style: none;
  padding: 10px;
  cursor: pointer;
  color: #333;
}

.submenuClient li:hover {
  background-color: #ddd;
  border-radius: 5px;
}

/* Content Styling */
.contentContainer {
  flex: 1 1;
  padding: 20px;
}

/* Live Class Section */
.liveClassContainer {
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
}

.header {
  display: flex;
  gap: 10px;
}

.tab {
  padding: 10px 15px;
  cursor: pointer;
  border: none;
  background-color: #f0f0f0;
}

.tab.active {
  background-color: #007bff;
  color: white;
}

.inputContainer {
  margin: 20px 0;
}

.inputContainer input {
  display: block;
  margin: 10px 0;
  padding: 8px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.addBtn {
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.addedClasses .classItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #ddd;
  margin: 10px 0;
}

.deleteBtn {
  background-color: #ff4d4f;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/studentSideBar.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* Sidebar Styling */\n.sidebarContainer {\n  background-color: #f9f9f9;\n  width: 240px;\n  height: 100vh;\n  padding: 20px;\n  border-right: 1px solid #ddd;\n}\n\n.submenuClient p {\n  font-weight: bold;\n  margin: 10px 0;\n}\n\n.submenuClient li {\n  list-style: none;\n  padding: 10px;\n  cursor: pointer;\n  color: #333;\n}\n\n.submenuClient li:hover {\n  background-color: #ddd;\n  border-radius: 5px;\n}\n\n/* Content Styling */\n.contentContainer {\n  flex: 1;\n  padding: 20px;\n}\n\n/* Live Class Section */\n.liveClassContainer {\n  border: 1px solid #ddd;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n.header {\n  display: flex;\n  gap: 10px;\n}\n\n.tab {\n  padding: 10px 15px;\n  cursor: pointer;\n  border: none;\n  background-color: #f0f0f0;\n}\n\n.tab.active {\n  background-color: #007bff;\n  color: white;\n}\n\n.inputContainer {\n  margin: 20px 0;\n}\n\n.inputContainer input {\n  display: block;\n  margin: 10px 0;\n  padding: 8px;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.addBtn {\n  padding: 8px 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.addedClasses .classItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid #ddd;\n  margin: 10px 0;\n}\n\n.deleteBtn {\n  background-color: #ff4d4f;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
